import React from "react";
import { connect } from "react-redux";
import style from "./style.css";
import Item from "./Item";
import { Flex, Button, SVGButton } from "/app/src/component";
import { history } from "/app/src/store";
import QuickResponseModel from "/app/src/model/QuickResponse/model";

class QuickResponseModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchInput: "",
    };
    this._renderItems = this._renderItems.bind(this);
    this._renderNoItems = this._renderNoItems.bind(this);
    this._itemSelected = this._itemSelected.bind(this);
    this._searchInputHandler = this._searchInputHandler.bind(this);
    this._setWrapperRef = this._setWrapperRef.bind(this);
    this._onCreateQuickResponseClick = this._onCreateQuickResponseClick.bind(
      this
    );
  }

  componentDidMount() {
    document.addEventListener("mousedown", this._handleOutsideClick);
    this.props.dispatch(QuickResponseModel.read());
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this._handleOutsideClick);
  }

  _setWrapperRef(node) {
    this.wrapperRef = node;
  }

  _itemSelected(text) {
    this.props.onSelected(text);
  }
  _searchInputHandler(event) {
    this.setState({ searchInput: event.target.value });
  }

  _onCreateQuickResponseClick() {
    history.push({ pathname: "/chatSettings/quickResponse" });
  }

  _renderItems() {
    const ListComponents = [];
    this.props.quickResponses.toJS().forEach((response) => {
      ListComponents.push(
        <Item
          response={response}
          key={response.id}
          onClick={() => {
            this._itemSelected(response.quick_response);
            this.props.focusTextArea();
          }}
          searchInput={this.state.searchInput}
        />
      );
    });
    return ListComponents;
  }

  _renderNoItems() {
    return (
      <Flex grow column>
        <Flex center mt="30px">
          <img
            alt=""
            className={style.NoItemIcon}
            src="/images/ChatSettings.png"
          />
        </Flex>
        <Flex className={style.NoItemText} center mt="10px">
          Du har inte konfiguerat några snabbsvar.
        </Flex>
        <Flex center mt="40px">
          <Button
            className={style.NoItemButton}
            text="Konfiguera snabbsvar"
            onClick={this._onCreateQuickResponseClick}
          />
        </Flex>
      </Flex>
    );
  }

  render() {
    return (
      <Flex className={style.QuickResponseModal} column>
        <div ref={(node) => (this.testRef = node)}>
          <Flex className={style.Header} center>
            <SVGButton
              src="/images/ChatQuickResponse.svg"
              text="Snabbsvar"
              disabled
              color="blue"
            />
          </Flex>
          {this.props.quickResponses.size > 0 && (
            <Flex className={style.Search}>
              <input
                style={{ fontSize: "18px" }}
                onChange={this._searchInputHandler}
                value={this.searchInput}
                placeholder="Sök..."
                className={style.SearchInput}
              />
              <SVGButton
                src="/images/Search.svg"
                disabled
                color="lightgrey"
                width="50px"
                background="white"
                borderRadius="0px"
              />
            </Flex>
          )}
          <div className={style.ItemsWrapperOuter}>
            <div className={style.ItemsWrapperInner}>
              {this.props.quickResponses.size > 0
                ? this._renderItems()
                : this._renderNoItems()}
            </div>
          </div>
        </div>
      </Flex>
    );
  }
}

export default connect()(QuickResponseModal);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/Conversation/QuickResponseModal/index.js